import { render, staticRenderFns } from "./JudgesView.vue?vue&type=template&id=69a691ee"
import script from "./JudgesView.vue?vue&type=script&lang=js"
export * from "./JudgesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports